import { Injectable } from "@angular/core";
import { LocationsRepository } from "../../../../core/repositories";
import {
  AddEditLocationRequest,
  GeoAddress,
  GetLocationsRequest,
  Location
} from "../../../../core/domain";
import { from, map, Observable, of, reduce } from "rxjs";
import { LocationMockEntity } from "./entities/location-mock-entity";
import { LocationMockRepositoryMapper } from "./entities/location-mock-repository-mapper";
import {
  BulkUpdateLocationRequest
} from "planning-portal-library/src/lib/core/domain/requests/locations/bulk-update-location.request";
import { GeoCoordinatesRequest } from "planning-portal-library/src/lib/core/domain/requests/geo-coordinates";
import { BaseGridResponse } from "../../../shared/base-grid.response";
import { BaseRequest } from "../../../shared/base.request";

@Injectable({ providedIn: 'root' })
export class LocationMockRepository  {
  bulkUpdateLocation(request: BulkUpdateLocationRequest): Observable<boolean> {
    throw new Error("Method not implemented.");
  }

  private readonly locationMapper = new LocationMockRepositoryMapper();


  locations: LocationMockEntity[] = [
    {
      id: "1",
      locationId: "2",
      name: "SynergyIT",
      address: "Al-Rehman Plaza, G11, Isb.",
      latitude: 10,
      longitude: 20,
      postalCode: "123",
      city: "city",
      country: "country",
      serviceTime: "00:00:00",
      stopTime: "00:00:00",
      servicesCount: 0,
      deliveryUnits: "asdsa"

    }
  ];

  constructor() {
    //super();
  }



  getLocations(request: BaseRequest<GetLocationsRequest>): Observable<BaseGridResponse<Location>> {
    return from(this.locations)
    .pipe(map(this.locationMapper.mapFrom))
    .pipe(reduce((items: Location[], item: Location) => [...items, item], []))
    .pipe(map((locations) => {
          return {
            data: locations,
            totalRecords: locations.length
          };
    }));
}

  addLocation(param: AddEditLocationRequest): Observable<boolean> {
    const location: LocationMockEntity = {
      locationId: param.locationId,
      name: param.locationName,
      address: param.address,
      latitude: param.geoAddress?.latitude,
      longitude: param.geoAddress?.longitude,
      postalCode: param.postalCode,
      city: param.city,
      country: param.country,
      // pickupWeight: param.pickupWeight,
      // pickupVolume: param.pickupVolume,
      // pickupUnits: param.pickupUnits,
      // deliveryWeight: param.deliveryWeight,
      // deliveryVolume: param.deliveryVolume,
      // deliveryUnits: param.deliveryUnits,
      precedence: param.precedence,
      qualifications: param.qualifications,
      customData: param.customData
    };
    this.locations.push(location);
    return new Observable<boolean>;

  }

  editLocation(request: AddEditLocationRequest): Observable<boolean> {
    const index = this.locations.findIndex((obj) => obj.id === request.id);
    this.locations[index].id = request.id;
    this.locations[index].name = request.locationName;
    this.locations[index].address = request.address;
    this.locations[index].latitude = request.geoAddress?.latitude;
    this.locations[index].longitude = request.geoAddress?.longitude;
    this.locations[index].locationId = request.locationId;
    return new Observable<boolean>;
  }

  deleteLocation(request: string): Observable<boolean> {
    const index = this.locations.findIndex(x => x.id === request);
    delete this.locations[index];
    return of(true);
  }

  getGeoCoordinates(request: GeoCoordinatesRequest): Observable<GeoAddress> {
    throw new Error("Method not implemented.");
  }

}


